<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-warning">
            <h4 class="card-title">{{ isEditMode ? 'Edit Todo' : 'Add Todo' }}</h4>
            <p class="card-category">Complete todo details</p>
          </div>
          <div class="card-body">
            <form [formGroup]="todoForm" (ngSubmit)="submitForm()">
              <div class="row">
                <!-- Title -->
                <div class="col-md-6">
                  <mat-form-field class="w-100">
                    <mat-label>Title</mat-label>
                    <input matInput formControlName="title" placeholder="Enter title" />
                  </mat-form-field>
                </div>

                <!-- Due Date -->
                <div class="col-md-6">
                  <mat-form-field class="w-100">
                    <mat-label>Due Date</mat-label>
                    <input matInput [matDatepicker]="duePicker" formControlName="dueDate" placeholder="Choose date" />
                    <mat-datepicker-toggle matSuffix [for]="duePicker"></mat-datepicker-toggle>
                    <mat-datepicker #duePicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <!-- Description -->
                <div class="col-md-12">
                  <mat-form-field class="w-100">
                    <mat-label>Description</mat-label>
                    <textarea matInput rows="3" formControlName="description" placeholder="Enter description"></textarea>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <!-- Case -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Case</mat-label>
                    <mat-select formControlName="caseId">
                      <mat-option *ngFor="let c of cases" [value]="c.id">{{ c.caseNumber }}/{{ c.year }} - {{ c.client?.fullName }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Client -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Client</mat-label>
                    <mat-select formControlName="clientId">
                      <mat-option *ngFor="let client of clients" [value]="client.id">{{ client.fullName }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Diary -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Diary</mat-label>
                    <mat-select formControlName="diaryId">
                      <mat-option *ngFor="let diary of diaries" [value]="diary.id">{{ diary.hearingDate | date:'shortDate' }} - {{ diary.case?.caseNumber }}/{{ diary.case?.year }} - {{ diary.case?.client?.fullName }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <!-- Completion Status (only in edit mode) -->
              <div class="row" *ngIf="isEditMode">
                <div class="col-md-6">
                  <mat-checkbox formControlName="isCompleted">Is Completed</mat-checkbox>
                </div>
                <div class="col-md-6" *ngIf="todoForm.get('isCompleted')?.value">
                  <mat-form-field class="w-100">
                    <mat-label>Completed At</mat-label>
                    <input matInput [matDatepicker]="completedPicker" formControlName="completedAt" placeholder="Completion date" />
                    <mat-datepicker-toggle matSuffix [for]="completedPicker"></mat-datepicker-toggle>
                    <mat-datepicker #completedPicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <button mat-raised-button color="primary" type="submit" class="btn btn-primary pull-right" [disabled]="isSubmited" (click)="isSubmited = true">
                {{ isEditMode ? 'Update Todo' : 'Add Todo' }}
              </button>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
